/* Persistent mobile scroll controls for product recommendations and recent history. */
(() => {
  // Shopify can evaluate the theme asset more than once during section reloads.
  // Keep one controller alive so each source can only receive one control.
  if (window.__kProductScrollbarsInitialized) return;
  window.__kProductScrollbarsInitialized = true;
  // Remove controls left by an older cached copy before taking ownership.
  // This prevents a stale script and the current script from stacking bars.
  document.querySelectorAll('.k-product-scrollbar').forEach(bar => bar.remove());

  const mobile = window.matchMedia('(max-width: 749px)');
  const controls = new Map();
  let frame = 0;

  function schedule() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }

  const sizes = new ResizeObserver(schedule);

  function sync(state) {
    const { source, bar, input } = state;
    const max = Math.max(0, source.scrollWidth - source.clientWidth);
    const hidden = !mobile.matches || source.clientWidth === 0 || max <= 1;
    if (bar.hidden !== hidden) bar.hidden = hidden;
    if (bar.hidden) return;
    const fraction = Math.min(1, Math.max(0, Math.abs(source.scrollLeft) / max));
    input.value = String(Math.round(fraction * 1000));
    input.setAttribute('aria-valuetext', `${Math.round(fraction * 100)}%`);
    const width = input.clientWidth;
    const thumb = Math.min(width, Math.max(24, width * source.clientWidth / source.scrollWidth));
    input.style.setProperty('--k-scroll-thumb-width', `${thumb}px`);
  }

  function attach(source, host, label) {
    if (controls.has(source)) return;
    const bar = document.createElement('div');
    bar.className = 'k-product-scrollbar';
    bar.dataset.kProductScrollbarOwner = 'k-product-scrollbars';
    bar.hidden = true;
    const input = document.createElement('input');
    input.className = 'k-product-scrollbar__range';
    input.type = 'range';
    input.min = '0';
    input.max = '1000';
    input.step = '1';
    input.value = '0';
    input.setAttribute('aria-label', label);
    bar.appendChild(input);
    host.insertAdjacentElement('afterend', bar);
    source.setAttribute('data-k-product-scroll-track', '');
    const state = { source, bar, input, snap: null };
    controls.set(source, state);

    const endDrag = () => {
      if (state.snap !== null) {
        source.style.scrollSnapType = state.snap;
        state.snap = null;
      }
      schedule();
    };
    input.addEventListener('pointerdown', event => {
      state.snap = source.style.scrollSnapType;
      source.style.scrollSnapType = 'none';
      input.setPointerCapture(event.pointerId);
    });
    input.addEventListener('pointerup', endDrag);
    input.addEventListener('pointercancel', endDrag);
    input.addEventListener('lostpointercapture', endDrag);
    input.addEventListener('input', () => {
      const max = Math.max(0, source.scrollWidth - source.clientWidth);
      const sign = getComputedStyle(source).direction === 'rtl' ? -1 : 1;
      source.scrollLeft = sign * Number(input.value) / 1000 * max;
      schedule();
    });
    source.addEventListener('scroll', schedule, { passive: true });
    sizes.observe(source);
    sizes.observe(input);
  }

  function refresh() {
    frame = 0;
    document.querySelectorAll('.k-rv__grid').forEach(source => {
      attach(source, source, 'Scroll recently viewed products');
    });
    // Match only the visible mobile carousel in the intended More In This Style
    // section. Hidden desktop clones and card galleries must not get controls.
    document.querySelectorAll('.ui-test-product-list[id*="__pdp_more_style"] .hidden--desktop.resource-list__carousel slideshow-component.resource-list__carousel > slideshow-container > slideshow-slides').forEach(source => {
      const host = source.closest('.resource-list');
      if (host) attach(source, host, 'Scroll more products');
    });
    controls.forEach((state, source) => {
      if (!source.isConnected) {
        sizes.unobserve(source);
        sizes.unobserve(state.input);
        state.bar.remove();
        controls.delete(source);
      } else {
        sync(state);
      }
    });
  }

  // Recently viewed fills its cards asynchronously; theme editor sections also reload.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', schedule, true);
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
